module.exports = __webpack_public_path__ + "img/dice-tab-bg.0ff8126f.svg";